"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _common = require("@/utils/common");
var _library = require("library");
var _default = exports.default = {
  data: function data() {
    return {
      uploadUtil: {},
      pickerOptions1: {
        shortcuts: [{
          text: "今天",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date(new Date().setHours(0, 0, 0, 0));
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "昨天",
          onClick: function onClick(picker) {
            var end = new Date(new Date().setHours(23, 59, 59, 0)) - 24 * 60 * 60 * 1000;
            var start = new Date(new Date().setHours(0, 0, 0, 0));
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "上周",
          onClick: function onClick(picker) {
            var weekStartDate = (0, _common.getTime)(7);
            var start = new Date(weekStartDate);
            var end = start.getTime() + 6 * 24 * 60 * 60 * 1000;
            start.setTime(start.getTime());
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "本周",
          onClick: function onClick(picker) {
            var weekStartDate = (0, _common.getTime)(0);
            var end = new Date();
            var start = new Date(weekStartDate);
            start.setTime(start.getTime());
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "上个月",
          onClick: function onClick(picker) {
            var monthStart = (0, _common.getTime)(0, 2);
            var monthEnd = (0, _common.getTime)(0, 3);
            var end = new Date(monthEnd);
            var start = new Date(monthStart);
            start.setTime(start.getTime());
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "本月",
          onClick: function onClick(picker) {
            var monthStart = (0, _common.getTime)(0, 1);
            var end = new Date();
            var start = new Date(monthStart);
            start.setTime(start.getTime());
            picker.$emit("pick", [start, end]);
          }
        }]
      }
    };
  },
  computed: {
    // 默认时分秒(组合)
    datePickerRangeTime: function datePickerRangeTime() {
      return ["00:00:00", "23:59:59"];
    },
    // 快捷日期选择
    datePickerOptions: function datePickerOptions() {
      return {
        shortcuts: [{
          text: "今天",
          onClick: function onClick(picker) {
            var start = new Date();
            var end = new Date();
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "昨天",
          onClick: function onClick(picker) {
            var start = new Date();
            var end = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59);
            picker.$emit("pick", [new Date(getBeginYesterday()), new Date(getEndYesterday())]);
          }
        }, {
          text: "本周",
          onClick: function onClick(picker) {
            var start = new Date();
            var end = new Date();
            start.setDate(start.getDate() - start.getDay() + 1);
            start.setHours(0, 0, 0);
            end.setHours(23, 59, 59);
            console.log(start);
            picker.$emit("pick", [new Date(getBeginWeek()), end]);
          }
        }, {
          text: "上周",
          onClick: function onClick(picker) {
            var start = new Date();
            var end = new Date();
            start.setDate(start.getDate() - start.getDay() - 6);
            start.setHours(0, 0, 0, 0);
            console.log(start.getDate());
            end.setDate(start.getDate() + 6);
            end.setHours(23, 59, 59);
            picker.$emit("pick", [new Date(getBeginLastWeek()), new Date(getEndLastWeek())]);
          }
        }, {
          text: "本月",
          onClick: function onClick(picker) {
            var start = new Date();
            var end = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0);
            end.setHours(23, 59, 59);
            picker.$emit("pick", [new Date(getBeginMonth()), end]);
          }
        }, {
          text: "上月",
          onClick: function onClick(picker) {
            var start = new Date();
            var end = new Date();
            start.setMonth(start.getMonth() - 1);
            start.setDate(1);
            start.setHours(0, 0, 0);
            end.setMonth(end.getMonth());
            end.setDate(0);
            end.setHours(23, 59, 59);
            picker.$emit("pick", [new Date(getBeginLastMonth()), new Date(getEndLastMonth())]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var start = new Date();
            var end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0);
            end.setHours(23, 59, 59);
            picker.$emit("pick", [start, end]);
          }
        }]
      };
    }
  },
  created: function created() {
    this.uploadUtil = new _library.upload({
      env: process.env.NODE_ENV,
      model: 'filer'
    });
  },
  methods: {
    indexMethod: function indexMethod(index) {
      return index + this.listQuery.page_size * (this.listQuery.page_no - 1) + 1;
    },
    showConfirmAlert: function showConfirmAlert(message) {
      var _this = this;
      return new Promise(function (resolve) {
        var evt = /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.$confirm(message, {
                    title: "提示",
                    type: "warning"
                  });
                case 2:
                  return _context.abrupt("return", _context.sent);
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function evt() {
            return _ref.apply(this, arguments);
          };
        }();
        evt().then(function () {
          return resolve();
        }).catch(function () {});
      });
    }
  }
};